import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ViewChild,
  Input,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { hasAnonymization } from '@collections/users';
import { Store } from '@ngrx/store';
import { TalentPoolsService } from '@shared/services/talent-pools.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { Task } from 'mojo-tasks';
import { getFormat, getDate } from '@shared';

@Component({
  selector: 'mojo-add-task-item',
  templateUrl: './add-task-item.component.html',
  styleUrls: ['./add-task-item.component.scss'],
})
export class AddTaskItemComponent implements OnInit, OnDestroy {
  @Output() taskCreated = new EventEmitter<Partial<Task>>();
  @Output() isAssignOpened = new EventEmitter<boolean>();
  @Output() datePickerChangedState = new EventEmitter<boolean>();
  @Input() width;
  @ViewChild('trigger') menuTrigger: MatMenuTrigger;
  @Input() entityName: string;
  longName: string;
  disabledToolTip = true;
  hasAnonymization$ = this.store.select(hasAnonymization);
  form = this.fb.group({
    description: ['', [Validators.required, Validators.minLength(1)]],
    date: [null, Validators.required],
  });
  getFormat = getFormat;
  getDate = getDate;
  userInput: UntypedFormControl = new UntypedFormControl(null);

  formUser: UntypedFormGroup = new UntypedFormGroup({
    userInput: this.userInput,
  });

  today = new Date();
  subs = new Subscription();
  constructor(
    private fb: UntypedFormBuilder,
    private store: Store,
    public talentPoolsService: TalentPoolsService,
  ) {}

  ngOnInit() {
    this.subs.add(
      this.form.controls.date.valueChanges.subscribe((val: Date) => {
        const date = new Date(val);
        this.form.patchValue(
          {
            date: this.getDate(date),
          },
          { emitEvent: false },
        );
      }),
    );
  }

  ngOnDestroy() {
    this.isAssignOpened.emit(false);
    this.subs.unsubscribe();
  }

  createTask() {
    let payload: Partial<Task> = {
      description: this.form.value.description,
      dueDate: this.form.value.date,
    };
    if (this.userInput?.value?.id) {
      payload = {
        ...payload,
        assignedUser: this.userInput?.value?.id,
        entityName: this.entityName,
      };
    }
    this.taskCreated.emit(payload);
  }

  getName() {
    if (this.userInput.value?.name) {
      if (this.userInput.value.name.length > 14) {
        this.longName = this.userInput?.value.name;
        this.disabledToolTip = false;
      } else {
        this.disabledToolTip = true;
      }
      return this.userInput.value.name.length > 14
        ? this.userInput.value.name.substring(0, 14) + '...'
        : this.userInput.value.name;
    } else {
      return 'Assign';
    }
  }
}
